import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthorizationTypeEnum } from '@shared/enums/authorization-type.enum';
import { AuthService } from '@shared/services/auth.service';
import { Observable } from 'rxjs';

@Injectable()
export class DashlyHttpInterceptor implements HttpInterceptor {
  private readonly authService = inject(AuthService);

  intercept(req: HttpRequest<object>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // assets needs to use local in develop
    if (req.url.search('assets') >= 0 || req.url.startsWith('https://storage.googleapis.com')) {
      return next.handle(req);
    }

    const accessCode = this.authService.getAccessCode();
    const token = accessCode || this.authService.token();
    const authType = accessCode ? AuthorizationTypeEnum.Code : AuthorizationTypeEnum.Token;

    if (token == null) return next.handle(req.clone());

    const clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Authorization-Type': authType,
      },
    });

    return next.handle(clonedRequest);
  }
}
